import React, { useState, useEffect } from 'react';
import { ITooltipProps, Tooltip } from "../Tooltip";

interface IDelayedTooltipProps extends ITooltipProps {
    delay: number,
    children: React.ReactNode
}

export const DelayedTooltip: React.FC<IDelayedTooltipProps> = ({ delay, ...props }) => {
    const [visible, setVisible] = useState(false);
    const [hovering, setHovering] = useState(false);

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (hovering) {
            timer = setTimeout(() => setVisible(true), delay);
        } else {
            clearTimeout(timer);
            setVisible(false);
        }
        return () => clearTimeout(timer);
    }, [hovering, delay]);

    return (
        <div onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)}>
            {visible ? <Tooltip {...props} /> : props.children}
        </div>
    );
};